// Admin → Carga de envíos. Ver "LYNX — unificación External API/Admin/
// Seller": el alta ahora es un único POST /v2/deliveries atómico (Store+
// Account+precio+lynx_code), el formulario real vive en
// components/deliveries/DeliveryIntakeForm.tsx -- compartido con Seller,
// nunca duplicado acá.
import React, { useEffect, useState } from "react";
import Card from "../components/ui/Card";
import { useAuth } from "../context/AuthContext";
import { authFetch } from "../lib/authFetch";
import DeliveryIntakeForm, { DeliveryIntakeStore, DeliveryCreatedResult } from "../components/deliveries/DeliveryIntakeForm";
import DeliveryCreatedModal from "../components/deliveries/DeliveryCreatedModal";

const pageWrapStyle: React.CSSProperties = { display: "flex", flexDirection: "column", gap: "20px" };
const titleStyle: React.CSSProperties = { margin: 0, fontSize: "34px", fontWeight: 800, color: "var(--text-primary)", letterSpacing: "-0.03em" };
const sectionTitleStyle: React.CSSProperties = { margin: 0, fontSize: "18px", fontWeight: 700, color: "var(--text-primary)" };
const sectionTextStyle: React.CSSProperties = { margin: "6px 0 18px 0", color: "var(--text-secondary)", fontSize: "14px" };

function pickArray<T>(payload: { [key: string]: T[] | undefined }, keys: string[]): T[] {
  for (const key of keys) {
    const value = payload[key];
    if (Array.isArray(value)) return value;
  }
  return [];
}

export default function DeliveriesLoad() {
  const { token } = useAuth();

  const [stores, setStores] = useState<DeliveryIntakeStore[]>([]);
  const [loading, setLoading] = useState(true);
  const [created, setCreated] = useState<DeliveryCreatedResult | null>(null);

  useEffect(() => {
    const loadStores = async () => {
      setLoading(true);
      try {
        const res = await authFetch("/v2/stores", { token });
        const json = await res.json().catch(() => ({} as any));
        if (!res.ok || json?.ok === false) throw new Error(json?.error);
        setStores(pickArray<DeliveryIntakeStore>(json, ["stores", "data", "result"]));
      } catch {
        setStores([]);
      } finally {
        setLoading(false);
      }
    };
    loadStores();
  }, [token]);

  return (
    <div style={pageWrapStyle}>
      <h1 style={titleStyle}>Carga de envíos</h1>

      <Card>
        <h2 style={sectionTitleStyle}>Nuevo envío manual</h2>
        <p style={sectionTextStyle}>
          Elegí la Store y la Account del envío -- el precio se calcula automáticamente según el código postal.
        </p>

        <DeliveryIntakeForm token={token} stores={stores} storesLoading={loading} onCreated={setCreated} />
      </Card>

      {created ? (
        <DeliveryCreatedModal result={created} token={token} onClose={() => setCreated(null)} />
      ) : null}
    </div>
  );
}
